import OrianaKou from "./ActiveHeadshots/Oriana Kou.webp";
import CurtisYang from "./ActiveHeadshots/Curtis Yang.webp";
import JessicaChoi from "./ActiveHeadshots/Jessica Choi.webp";
import AlexLi from "./ActiveHeadshots/Alex Li.webp";
import JustinLin from "./ActiveHeadshots/Justin Lin.webp";
import JacobMark from "./ActiveHeadshots/Jacob Mark.webp";
import VinhTran from "./ActiveHeadshots/Vinh Tran.webp";
import TiffanyVo from "./ActiveHeadshots/Tiffany Vo.webp";
import DominicPagano from "./ActiveHeadshots/Dominic Pagano.webp";
import AarushInamdar from "./ActiveHeadshots/Aarush Inamdar.webp";
import AlexKao from "./ActiveHeadshots/Alex Kao.webp";
import SarahKim from "./ActiveHeadshots/Sarah Kim.webp";
import YanAmyZhou from "./ActiveHeadshots/Yan Amy Zhou.webp";
import AlexaAncheta from "./ActiveHeadshots/Alexa Ancheta.webp";
import TiffanyCheng from "./ActiveHeadshots/Tiffany Cheng.webp";
import IzellaHan from "./ActiveHeadshots/Izella Han.webp";
import AnnaShan from "./ActiveHeadshots/Anna Shan.webp";
import IsabellaTan from "./ActiveHeadshots/Isabella Tan.webp";
import AmyTu from "./ActiveHeadshots/Amy Tu.webp";
import MasonWhang from "./ActiveHeadshots/Mason Whang.webp";
import EdmundMa from "./ActiveHeadshots/Edmund Ma.webp";
import ChrisWang from "./ActiveHeadshots/Chris Wang.webp";
import AndrewSou from "./ActiveHeadshots/Andrew Sou.webp";
import AnnieNguyen from "./ActiveHeadshots/Annie Nguyen.webp";
import AlexisLin from "./ActiveHeadshots/Alexis Lin.webp";
import CatelynnChen from "./ActiveHeadshots/Catelynn Chen.webp";
import ElleHsu from "./ActiveHeadshots/Elle Hsu.webp";
import AnujPatel from "./ActiveHeadshots/Anuj Patel.webp";
import RithikaPothi from "./ActiveHeadshots/Rithika Pothi.webp";
import AndrewHauber from "./ActiveHeadshots/Andrew Hauber.webp";
import AllenLai from "./ActiveHeadshots/Allen Lai.webp";
import CindyChen from "./ActiveHeadshots/Cindy Chen.webp";
import DanielKim from "./ActiveHeadshots/Daniel Kim.webp";
import DonnyChau from "./ActiveHeadshots/Donny Chau.webp";
import KatieWang from "./ActiveHeadshots/Katie Wang.webp";
import LaurenCho from "./ActiveHeadshots/Lauren Cho.webp";
import MaxVano from "./ActiveHeadshots/Max Vano.webp";
import MinaNguyen from "./ActiveHeadshots/Mina Nguyen.webp";
import PranayMach from "./ActiveHeadshots/Pranay Macherla.webp";
import DanielVercueil from "./ActiveHeadshots/Daniel Verceil.webp";
import TylerHo from "./ActiveHeadshots/Tyler Ho.webp";
import TravisYen from "./ActiveHeadshots/Travis Yen.webp";
import TommyNguyen from "./ActiveHeadshots/Tommy Nguyen.webp";
import RyanPark from "./ActiveHeadshots/Ryan Park.webp";
import NicoSimonian from "./ActiveHeadshots/Nico Simonian.webp";
import MelindaDo from "./ActiveHeadshots/Melinda Do.webp";
import LoganKim from "./ActiveHeadshots/Logan Kim.webp";
import ErinTran from "./ActiveHeadshots/Erin Tran.webp";
import CarlQiao from "./ActiveHeadshots/Carl Qiao.webp";
import BrandonKoh from "./ActiveHeadshots/Brandon Koh.webp";
import BradlyHo from "./ActiveHeadshots/Bradly Ho.webp";
import AlexSriprathum from "./ActiveHeadshots/Alex Sriprathum.webp";
import AshleyKang from "./ActiveHeadshots/Ashley Kang.webp";
import DavidKim from "./ActiveHeadshots/David Kim.webp";
import AshlynWong from "./ActiveHeadshots/Ashlyn Wong.webp";
import BrandonPeng from "./ActiveHeadshots/Brandon Peng.webp";
import GabrielleReyes from "./ActiveHeadshots/Gabrielle Reyes.webp";
import MillicentMei from "./ActiveHeadshots/Millicent Mei.webp";
import GraceRyu from "./ActiveHeadshots/Grace Ryu.webp";
import HenryLee from "./ActiveHeadshots/Henry Lee.webp";
import RishiMurumkar from "./ActiveHeadshots/Rishi Murumkar.webp";
import SamanthaLee from "./ActiveHeadshots/Samantha Lee.webp";
import NicoleKwan from "./ActiveHeadshots/Nicole Kwan.webp";

import DefaultHeadshot from "./ActiveHeadshots/Default Headshot.webp";

export const headshotHash = {
  "Aarush Inamdar": AarushInamdar,
  "Alex Kao": AlexKao,
  "Oriana Kou": OrianaKou,
  "Curtis Yang": CurtisYang,
  "Daniel Vercueil": DanielVercueil,
  "Jessica Choi": JessicaChoi,
  "Alex Li": AlexLi,
  "Justin Lin": JustinLin,
  "Jacob Mark": JacobMark,
  "Vinh Tran": VinhTran,
  "Tiffany Vo": TiffanyVo,
  "Dominic Pagano": DominicPagano,
  "Sarah Kim": SarahKim,
  "Yan Amy Zhou": YanAmyZhou,
  "Alexandra Ancheta": AlexaAncheta,
  "Tiffany Cheng": TiffanyCheng,
  "Izella Han": IzellaHan,
  "Anna Shan": AnnaShan,
  "Isabella Tan": IsabellaTan,
  "Amy Tu": AmyTu,
  "Mason Whang": MasonWhang,
  "Edmund Ma": EdmundMa,
  "Chris Wang": ChrisWang,
  "Andrew Sou": AndrewSou,
  "Annie Nguyen": AnnieNguyen,
  "Alexis Lin": AlexisLin,
  "Catelynn Chen": CatelynnChen,
  "Elle Hsu": ElleHsu,
  "Anuj Patel": AnujPatel,
  "Rithika Pothi": RithikaPothi,
  "Andrew Hauber": AndrewHauber,
  "Allen Lai": AllenLai,
  "Cindy Chen": CindyChen,
  "Daniel Kim": DanielKim,
  "Donny Chau": DonnyChau,
  "Katie Wang": KatieWang,
  "Lauren Cho": LaurenCho,
  "Max Vano": MaxVano,
  "Pranay Macherla": PranayMach,
  "Mina Nguyen": MinaNguyen,
  "Tyler Ho": TylerHo,
  "Travis Yen": TravisYen,
  "Tommy Nguyen": TommyNguyen,
  "Ryan Park": RyanPark,
  "Nico Simonian": NicoSimonian,
  "Melinda Do": MelindaDo,
  "Logan Kim": LoganKim,
  "Erin Tran": ErinTran,
  "Carl Qiao": CarlQiao,
  "Brandon Koh": BrandonKoh,
  "Bradly Ho": BradlyHo,
  "Alex Sriprathum": AlexSriprathum,
  "Ashley Kang": AshleyKang,
  "David Kim": DavidKim,
  "Ashlyn Wong": AshlynWong,
  "Brandon Peng": BrandonPeng,
  "Gabrielle Reyes": GabrielleReyes,
  "Millicent Mei": MillicentMei,
  "Grace Ryu": GraceRyu,
  "Henry Lee": HenryLee,
  "Rishi Murumkar": RishiMurumkar,
  "Samantha Lee": SamanthaLee,
  "Nicole Kwan": NicoleKwan,
  "Default Headshot": DefaultHeadshot,
};
